<template>
  <v-layout align-start justify-center class="my-10" mx-0 row wrap>
    <v-flex xs2 sm2 md2 v-if="$vuetify.breakpoint.mdAndUp" id="panel">
      <v-card class="mr-3" tile>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="mb-4">
              <strong>Crédito Automotriz</strong>
            </div>
            <v-list-item-title class="mb-1">
              <p>
                <a
                  href="#nuevo"
                  v-smooth-scroll="{
                    duration: 1000,
                    offset: -100,
                    container: '',
                    updateHistory: false,
                  }"
                  style="text-decoration: none; cursor: pointer;"
                  @click="panel=[0]"
                >AUTO NUEVO</a>
              </p>
            </v-list-item-title>
            <v-list-item-title class="mb-1">
              <p>
                <a
                  v-smooth-scroll="{
                    duration: 1000,
                    offset: -100,
                    container: '',
                    updateHistory: false,
                  }"
                  style="text-decoration: none; cursor: pointer;"
                  @click="panel=[1]"
                >AUTO SEMINUEVO</a>
              </p>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-flex>
    <v-flex xs10 sm10 md10 id="expansion-panel_right">
      <v-expansion-panels mandatory multiple v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header id="nuevo">
            <h2>
              <strong>Crédito de Auto Nuevo</strong>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout align-start justify-center row wrap>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase white--text my-12">{{title1}}</h3>
                    <ul>
                      <li
                        class="white--text my-10 font-weight-bold"
                        v-for="(item, index) in items"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase primary_dark--text my-12">{{title2}}</h3>
                    <ul>
                      <li
                        :class="[$vuetify.breakpoint.mdAndUp ? 'my-7' : 'my-9']"
                        class="primary_dark--text font-weight-bold"
                        v-for="(item, index) in items2"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase white--text my-12">{{title3}}</h3>
                    <ul>
                      <li
                        class="white--text my-9 font-weight-bold"
                        v-for="(item, index) in items3"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase primary_dark--text my-12">{{title4}}</h3>
                    <ul>
                      <li
                        class="primary_dark--text my-7 font-weight-bold"
                        v-for="(item, index) in items4"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                    <div class="justify-start my-4" style="color: #1a5c96;font-size: 0.8rem;">
                      Todos los contratos de nuestros productos, se encuentran debidamente registrados ante la CONDUSEF, en el RECA y pueden ser consultados en las siguientes páginas oficiales:<br>
                      <a  style="color: #1a5c96;font-weight: bold;" href="https://www.gob.mx/condusef/" target="_blank">https://www.gob.mx/condusef/</a>
                      <br>
                      <a  style="color: #1a5c96;font-weight: bold;" href="https://phpapps.condusef.gob.mx/reca/_index.php"  target="_blank">https://phpapps.condusef.gob.mx/reca/_index.php</a>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header id="seminuevo">
            <h2>
              <strong>Crédito Auto Seminuevo</strong>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout align-start justify-center row wrap>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3
                      :class="[$vuetify.breakpoint.xl ? 'my-10' : 'my-6']"
                      class="text-uppercase white--text"
                    >{{title1}}</h3>
                    <ul>
                      <li
                        :class="[$vuetify.breakpoint.xl ? 'my-11' : 'my-5']"
                        class="white--text my-11 font-weight-bold"
                        v-for="(item, index) in items5"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase primary_dark--text my-12">{{title2}}</h3>
                    <ul>
                      <li
                        :class="[$vuetify.breakpoint.xl ? 'my-10' : 'my-9']"
                        class="primary_dark--text font-weight-bold"
                        v-for="(item, index) in items6"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase white--text my-5">{{title3}}</h3>
                    <ul>
                      <li
                        class="white--text my-12 font-weight-bold"
                        v-for="(item, index) in items7"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3 class="text-uppercase primary_dark--text my-5">{{title4}}</h3>
                    <ul>
                      <li
                        class="primary_dark--text my-7 font-weight-bold"
                        v-for="(item, index) in items15"
                        :key="index"
                      >{{ item.message }}</li>
                    </ul>
                    <div class="justify-start my-4" style="color: #1a5c96;font-size: 0.8rem;">
                      Todos los contratos de nuestros productos, se encuentran debidamente registrados ante la CONDUSEF, en el RECA y pueden ser consultados en las siguientes páginas oficiales:<br>
                      <a  style="color: #1a5c96;font-weight: bold;" href="https://www.gob.mx/condusef/" target="_blank">https://www.gob.mx/condusef/</a>
                      <br>
                      <a  style="color: #1a5c96;font-weight: bold;" href="https://phpapps.condusef.gob.mx/reca/_index.php"  target="_blank">https://phpapps.condusef.gob.mx/reca/_index.php</a>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-dialog
        :fullscreen="$vuetify.breakpoint.smAndDown"
        v-model="dialog"
        persistent
        max-width="700px"
      >
        <v-card>
          <v-card-title class="pb-0">
            <v-container class="pb-0">
              <p class="primary--text">Pre-solicitud de Crédito</p>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Nombre completo *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Correo electronico *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Direccion del negocio * "></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Colonia *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Cuidad o localidad *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Código postal *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-text-field v-mask="'(###)-###-####'" label="Telefono con lada *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-autocomplete
                    :items="['Abarrotes', 'Carniceria', 'Constructora', 'Consultorios médicos', 'Dulcerías', 'Electronica y Computo', 'Farmacias', 'Fotografia (estudio)', 'Fruterías','Hoteles y Moteles','Imprentas y editoriales','Joyeria y relojeria','Laboratorios clínicos','Librerias','Madererías','Marisquerías','Mueblería','Panaderias','Purificadora de agua','Refaccionaria','Restaurante','Rosticeria','Talleres','Telefonia','Tortillerias','Videoclub','Vinos y licores','Otro comercio o negocio']"
                    label="Giro de su negocio * "
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <small>*indica el campo requerido</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" text @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary_dark" text @click="dialog = false">Enviar solicitud</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<style scoped>
</style>
<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask
  },
  mounted() {
    var el = document.getElementById("panel");
    var el2 = document.getElementById("expansion-panel_right");
    var elTop =
      el.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top;

    window.addEventListener("scroll", function() {
      if (document.documentElement.scrollTop > elTop - 100) {
        el.style.position = "fixed";
        el.style.top = "115px";
        el.style.left = "0";
        el2.classList.add("offset-md-2");
      } else {
        el.style.position = "static";
        el.style.top = "auto";
        el.style.top = "auto";
        el.style.left = "auto";

        el2.classList.remove("offset-md-2");
      }
    });
  },
  props: ["image"],
  data() {
    return {
      panel: [0],
      dialog: false,
      title1: "Requisitos personas físicas con ingreso vía nómina",
      title2: "Requisitos personas físicas con actividad empresarial",
      title3: "Requisitos persona moral",
      title4: "Condiciones crediticias",
      title5: "Requisitos",
      items: [
        {
          message:
            "Identificación oficial (IFE, pasaporte vigente o cédula profesional)."
        },
        {
          message: "CURP."
        },
        {
          message: "Comprobante de domicilio (Luz, agua o teléfono)."
        },
        {
          message: "Comprobante de ingresos (4 últimos recibos de nómina)."
        },
        {
          message: "Estados de cuenta bancarios de la nómina (Últimos 3 meses)."
        },
        {
          message: "2 referencias personales."
        },
        {
          message: "Carta cotización del vehículo."
        },
        {
          message: "Factura original a la firma de contratos"
        },
        {
          message:
            "Copia de la póliza del seguro de cobertura amplia y comprobante de pago de la misma."
        }
      ],
      items2: [
        {
          message:
            "Identificación oficial (IFE, pasaporte vigente o cédula profesional)."
        },
        {
          message: "CURP."
        },
        {
          message: "Comprobante de domicilio (Luz, agua o teléfono)."
        },
        {
          message: "Declaración anual último año."
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses)."
        },
        {
          message: "Cédula de identificacion fiscal actualizada."
        },
        {
          message: "2 referencias (Una comercial, una personal o familiar)."
        },
        {
          message: "Carta Cotizacion del vehículo."
        },
        {
          message: "Factura original a la firma de contratos."
        },
        {
          message:
            "Copia de la póliza del seguro de cobertura amplia y comprobante de pago de la misma."
        }
      ],
      items3: [
        {
          message: "Acta Constitutiva."
        },
        {
          message: "Reporte de buró persona moral."
        },
        {
          message:
            "Representante legal (Identificación oficial, poder notariado y comprobante de domicilio)."
        },
        {
          message:
            "Comprobante de domicilio de la empresa (Luz, agua o teléfono)."
        },
        {
          message:
            "Copia simple de la constancia de la firma electrónica avanzada."
        },
        {
          message: "Declaración anual último año."
        },
        {
          message: "Estados Financieros (Último año y actual)."
        },
        {
          message: "Declaración de impuestos de los últimos 3 meses."
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses)."
        },
        {
          message: "Cédula de identificación fiscal actualizada."
        },
        {
          message: "2 referencias (Un comercial, un personal o familiar)."
        },
        {
          message: "Carta cotización del vehículo."
        },
        {
          message: "Factura original a la firma de contratos."
        },
        {
          message:
            "Copia de la poliza del seguro de cobertura amplia y comprobante de pago de la misma."
        }
      ],
      items4: [
        { message: "Financiamiento desde el 80% del valor del vehículo" },
        { message: "Tasa de interes anual desde el 14.90% mas iva" },
        { message: "Comisión por Apertura 4% mas iva" },
        {
          message: "Enganche a partir del 20%."
        },
        {
          message: "Plazos: 12, 24, 36 y hasta 60 meses."
        },
        { message: "Seguro Deudor 1%." },
      ],
      items5: [
        {
          message:
            "Identificación oficial (IFE, pasaporte vigente o cédula profesional)."
        },
        {
          message: "CURP."
        },
        {
          message: "Comprobante de domicilio (Luz, agua o teléfono)."
        },
        {
          message: "Comprobante de ingresos (4 últimos recibos de nómina)."
        },
        {
          message: "Estados de cuenta bancarios de la nómina (Últimos 3 meses)."
        },
        {
          message: "2 referencias personales."
        },
        {
          message: "Carta cotización del vehículo."
        },
        {
          message: "Factura de origen."
        },
        {
          message: "Altas y bajas del vehículo."
        },
        {
          message:
            "Copia de la póliza del seguro de cobertura amplia y comprobante de pago de la misma."
        },
        {
          message: "Avalúo de la unidad."
        },
        {
          message: "Copia del último pago de tenencia o refrendo."
        },
        {
          message: "Modelos no mayores a 5 años de antigüedad."
        }
      ],
      items6: [
        {
          message:
            "Identificación oficial (IFE, pasaporte vigente o cédula profesional)."
        },
        {
          message: "CURP."
        },
        {
          message: "Comprobante de domicilio (Luz, agua o teléfono)."
        },
        {
          message: "Declaración anual ultimo año."
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses)."
        },
        {
          message: "Cedula de identificacion fiscal actualizada."
        },
        {
          message: "2 referencias (Una comercial, una personal o familiar)."
        },
        {
          message: "Carta cotización del vehículo."
        },
        {
          message: "Factura de origen."
        },
        {
          message: "Altas y bajas del vehículo."
        },
        {
          message:
            "Copia de la poliza del seguro de cobertura amplia y comprobante de pago de la misma."
        },
        {
          message: "Avalúo de la unidad."
        },
        {
          message: "Copia del último pago de tenencia o refrendo."
        },
        {
          message: "Modelos no mayores a 5 años de antigüedad."
        }
      ],
      items7: [
        {
          message: "Acta Constitutiva."
        },
        {
          message: "Reporte de buró persona moral."
        },
        {
          message:
            "Representante legal (Identificación oficial, poder notariado y comprobante de domicilio)."
        },
        {
          message:
            "Comprobante de domicilio de la empresa (Luz, agua o teléfono)."
        },
        {
          message:
            "Copia simple de la constancia de la firma electrónica avanzada."
        },
        {
          message: "Declaración anual último año."
        },
        {
          message: "Estados financieros (Último año y actual)."
        },
        { message: "Declaración de impuestos de los últimos 3 meses." },
        { message: "Estados de cuenta bancarios (últimos 3 meses)." },
        { message: "Cédula de identificación fiscal actualizada." },
        { message: "2 referencias (Una comercial, una personal o familiar)." },
        { message: "Carta Cotización del vehículo." },
        { message: "Factura de origen." },
        {
          message: "Altas y bajas del vehículo."
        },
        {
          message:
            "Copia de la póliza del seguro de cobertura amplia y comprobante de pago de la misma."
        },
        {
          message: "Avalúo de la unidad."
        },
        {
          message: "Copia del último pago de tenencia o refrendo."
        },
        {
          message: "Modelos no mayores a 5 años de antigüedad."
        }
      ],
      items15: [
        {
          message: "Financiamiento hasta el 70% del valor avaluo del vehículo"
        },
        { message: "Tasa Interes ordinario anual desde 16.90% mas iva" },
        {
          message: "Comision por apertura 4% mas iva"
        },
        {
          message: "Enganche a partir del 30% sobre avalúo."
        },
        {
          message: "Plazos: 12, 24, 36 y hasta 48 meses."
        },
        {
          message: "Seguro deudor 1%."
        }
      ],
      condiciones_sitem_nuevo: [
        {
          message: "Sin enganche."
        },
        {
          message: "Plazos: 6 a 60 meses."
        },
        {
          message: "Financiamiento hasta el 100% del valor avalúo del vehículo."
        },
        {
          message: "Seguro Deudor 1%."
        },
        {
          message:
            "Pagos programados máximo 2 por años y no mayor a $17,500.00."
        }
      ],
      condiciones_sitem_seminuevo: [
        {
          message: "Sin enganche."
        },
        {
          message: "Plazos: 6 a 48 meses."
        },
        {
          message: "Financiamiento hasta el 100% del valor avalúo del vehículo."
        },
        {
          message: "Seguro Deudor 1%."
        },
        {
          message:
            "Pagos programados máximo 2 por años y no mayor a $17,500.00."
        }
      ],

      items9: [
        {
          message:
            "Identificación oficial (IFE, pasaporte vigente o cédula profesional)."
        },
        {
          message: "CURP."
        },
        {
          message: "Comprobante de domicilio (Luz, agua o teléfono)."
        },
        {
          message: "Comprobante de ingresos (4 últimos recibos de nómina)."
        },
        {
          message: "Carta de afiliación emitida por el sindicato."
        },
        {
          message: "Estados de cuenta bancarios de la nómina (Últimos 3 meses)."
        },
        {
          message: "2 referencias personales."
        },
        {
          message: "Carta cotización del vehículo."
        },
        {
          message: "Factura original."
        },
        {
          message: "Altas y bjas del vehículo."
        },
        {
          message:
            "Copia de la póliza del seguro de cobertura amplia y comprobante de pago de la misma."
        },
        {
          message: "Avaluo de la unidad."
        },
        {
          message: "Copia del ultimo pago de tenencia o refrendo."
        },
        {
          message: "Modelos no mayores a 5 años de antigüedad."
        }
      ],
      item10: [
        {
          message: "Sin enganche."
        },
        {
          message: "Plazos de 6 a 60 meses."
        },
        {
          message: "Financiamiento hasta el 100% del valor del vehículo."
        },
        {
          message: "Seguro Deudor 1%."
        },
        {
          message: "Pagos programados maximo 2 por año y no mayor a $17,500.00."
        }
      ],
      items11: [
        {
          message: "Sin enganche."
        },
        {
          message: "Plazos de 6 hasta 48 meses."
        },
        {
          message: "Financiamiento hasta el 100% del valor avalúo del vehículo."
        },
        {
          message: "Seguro Deudor 1%."
        },
        {
          message: "Pagos programados maximo 2 por año y no mayor a $17,500.00."
        }
      ]
    };
  }
};
</script>